import { getLocale } from '../../interstitials/components/learn-more/utils'
import fetchContent, { FetchContentParams } from '../../newInterstitials/utilities/fetchContent'

export async function startPrequalification(params: FetchContentParams, language: string, country: string) {
  const locale = getLocale({ language, country })
  const data = await fetchContent({ ...params, locale, path: 'v1/prequalification/start' })
  if (data?.prequalification_client_uri !== null) {
    const url = new URL(data.prequalification_client_uri)
    url.searchParams.set('locale', locale)
    window.location.replace(url.toString())
  }
}
